import moment from 'moment';
//局部显露
export const mixin = {
	data() {
		return {
			wxAppId: 'wxcd032fdf22dc5924',
			//测试环境
			url: 'http://test-9gameh5.laolongtang.com.cn/callback.html'
			//生产环境
			// url: 'http://9gameh5.laolongtang.com.cn/callback.html'
		}
	},
	methods: {
		//字符替换
		replaceTxt(txt) {
			let tmp = txt
			if(txt)
			{				
				return tmp.replaceAll(',',' / ');
			}
		},
		//字符串截取
		truncatedMessage(txt, maxLength) {
			if(txt)
			{				
				return txt.length > maxLength ? txt.slice(0, maxLength) + '...' : txt;
			}
		},
		//格式化时间
		formattedDate(timestamp) {
		  return moment(timestamp).format('yyyy-MM-DD');
		},
		//评论列表星级
		getListStarClass(star)
		{
			if(star !='')
			{
				return 'star_box s_' + star
			}
		},
		//批量替换玩乐热词
		patchReplace(hotKeywords, content, path)
		{
			let tmpContent = content
			if(hotKeywords.length>0 && content !='' && content !=null)
			{
				hotKeywords.forEach((item, index) => {
					tmpContent = tmpContent.replaceAll(''+item.Keyword+'','<a href=\"'+path+item.RecreationId+'\" class=\"hot_key\" target=\"_blank\">'+item.Keyword+'</a>')
				})
			}
			return tmpContent
		},
		//判断终端
		isMobile() {
			// const userAgent = navigator.userAgent || navigator.vendor || window.opera;
			// if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
			// 	return true; // 移动设备
			// } else {
			// 	return false; // 非移动设备，可能是PC或平板等
			// }
			
			const ua = navigator.userAgent;
			const isMobileSize = window.innerWidth < 900;
			const isMobileUA = /Mobile|Android|iPhone|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(ua);
			return isMobileSize && isMobileUA; // 同时满足屏幕尺寸和用户代理为手机特征时，认为是手机设备
			
		}
	}
}